import { ViewportDeviceType } from './types'

export const VIEWPORT_DEVICES: {
  [key in ViewportDeviceType]: {
    id: ViewportDeviceType
    name: string
    width: number | '100%'
  }
} = {
  [ViewportDeviceType.current]: {
    id: ViewportDeviceType.current,
    name: 'Current',
    width: '100%',
  },
  [ViewportDeviceType.desktop]: {
    id: ViewportDeviceType.desktop,
    name: 'Desktop',
    width: 1440,
  },
  [ViewportDeviceType.tablet]: {
    id: ViewportDeviceType.tablet,
    name: 'Tablet',
    width: 848,
  },
  [ViewportDeviceType.mobile]: {
    id: ViewportDeviceType.mobile,
    name: 'Mobile',
    width: 428,
  },
}
